import React, { useContext } from 'react';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { If } from 'utils';
import { Layout } from 'components';

import { AuthContext } from 'context/AuthContext';

export default function Header() {
  const { roles } = useContext(AuthContext);

  const isAdmin = _get(roles, 'admin', false);

  return (
    <Layout.Header isExtended logoClassName={styles.logo}>
      <Layout.Nav>
        <Layout.Nav.StoreSwitch />
        <Layout.Nav.RoleSwitch />
      </Layout.Nav>
      <Layout.Nav className="ml-auto">
        <Layout.Nav.Notifications />
        <Layout.Nav.User>
          <Layout.Nav.User.AccountSettingsOption />
          <Layout.Nav.User.ConnectStoreOption />
          <If test={!isAdmin}>
            <Layout.Nav.User.ChangePasswordOption />
          </If>
        </Layout.Nav.User>
      </Layout.Nav>
    </Layout.Header>
  );
}
